import { Stack } from 'expo-router';
import Header from '@/components/Layout/Header';
import { ApolloClient, ApolloProvider, NormalizedCacheObject } from '@apollo/client';
import getClient from '@/components/Apollo';
import { useEffect, useState } from 'react';
import { ActivityIndicator } from 'react-native-paper';
import { UserProvider } from '@/components/Auth/UserContext';

const MainLayout = () => {
  const [client, setClient] = useState<ApolloClient<NormalizedCacheObject> | undefined>();

  useEffect(() => {
    (async () => {
      setClient(await getClient());
    })();
  }, []);

  if (!client) {
    return <ActivityIndicator />;
  }

  return (
    <ApolloProvider client={client}>
      <UserProvider>
        <Stack
          screenOptions={{
            header: () => <Header />,
            headerStyle: { backgroundColor: 'red' },
          }}
        />
      </UserProvider>
    </ApolloProvider>
  );
};

export default MainLayout;
